module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="routing-tool routing-tool_validation">\n  <span translate>Calculate errors:</span>\n  <button class="btn btn-default" ng-click="$ctrl.validate()" ng-disabled="$ctrl.isOngoing()" translate>\n    Calculate\n  </button>\n  <span ng-show="$ctrl.validateState" ng-bind-html="$ctrl.message"></span>\n</div>\n<div class="routing-tool routing-tool_publish">\n  <span translate>Validate itineraries:</span>\n  <button class="btn btn-default" ng-click="$ctrl.publish()" ng-disabled="$ctrl.isOngoing()" translate>\n    Validate\n  </button>\n  <span ng-show="$ctrl.publishState" ng-bind-html="$ctrl.message"></span>\n</div>\n';

}
return __p
}